/**
 * mwApp.localizations module <br>
 * Work with localizations: show/add/edit/remove
 *
 * @namespace mwApp/devices
 */

import AddLocalizationCtrl from './addLocalization.controller'
import LocalizationsCtrl from './localizations.controller'
import localizationsConfig from './localizations.config'

export default
angular.module('mwApp.localizations', [])
  .config(localizationsConfig)
  .controller('LocalizationsCtrl', LocalizationsCtrl)
  .controller('AddLocalizationCtrl', AddLocalizationCtrl)
